export default __webpack_public_path__ + "static/media/slider-3.2c8ce6bf.jpg";